import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store/index';
import Compania from '../views/Configurar/Generales/Index.vue';
import EditarEmpresa from '../views/Configurar/EditarEmpresa/Index.vue';
import Empresa from '../views/Configurar/Empresas/Index.vue';
import ParametrizarConvenio from '../views/Configurar/ParametrizarConvenio/Index.vue';
import Home from '../views/Home.vue';
import Log from '../views/Log/Log/Index.vue';
import ConsultaCredito from '../views/Empleados/ConsultaCreditos/Index.vue';
import ImportarDatos from '../views/Empleados/ImportarDatos/Index.vue';
import RegistrarDatos from '../views/Empleados/RegistrarDatos/Index.vue';
import Retirados from '../views/Empleados/Retirados/Index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Account/Login/Index.vue'),
    meta: {
      libre: true,
    },
  },
  {
    path: '/gestionusuarios',
    name: 'gestionusuario',
    component: () => import('../views/Usuarios/Gestion/Index.vue'),
    meta: {
      acceso: true,
    },
  },
  {
    path: '/parametrizacioncompania',
    name: 'parametrizacioncompania',
    component: Compania,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/parametrizacionempresa',
    name: 'parametrizacionempresa',
    component: Empresa,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/parametrizacionempresa/:nit/editar',
    name: 'editarempresa',
    component: EditarEmpresa,
    meta: {
      acceso: true,
    },
    props: {
      estaEditando: true,
    },
  },
  {
    path: '/parametrizacionempresa/crear',
    name: 'registrarempresa',
    component: EditarEmpresa,
    meta: {
      acceso: true,
    },
    props: {
      estaEditando: false,
    },
  },
  {
    path: '/parametrizacionempresa/convenio/:nit',
    name: 'parametrizarconvenio',
    component: ParametrizarConvenio,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/myperfil',
    name: 'myperfil',
    component: () => import('../views/Usuarios/MyPerfil.vue'),
    meta: {
      acceso: true,
    },
  },
  {
    path: '/recuperar-contrasena',
    name: 'EnviarCorreo',
    component: () => import('../views/Account/OlvidoContrasena/Index.vue'),
    meta: {
      libre: true,
    },
  },
  {
    path: '/cambiar-contrasena',
    name: 'CambioContrasena',
    props: route => ({
      token: route.query.tokenPass,
    }),
    component: () => import('../views/Account/CambiarContrasena/Index.vue'),
    meta: {
      libre: true,
    },
  },
  {
    path: '/registrardatos',
    name: 'registrardatos',
    component: RegistrarDatos,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/importardatos',
    name: 'importardatos',
    component: ImportarDatos,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/consultacredito',
    name: 'consultacredito',
    component: ConsultaCredito,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/empleados-retirados',
    name: 'empleadosRetirados',
    component: Retirados,
    meta: {
      acceso: true,
    },
  },
  {
    path: '/gestion',
    name: 'gestion',
    component: () => import('../views/Empleados/GestionEmpleados/Index.vue'),
    meta: {
      acceso: true,
    },
  },
  {
    path: '/gestion/registrar-empleado',
    name: 'registrarEmpleado',
    component: () => import('../views/Empleados/GestionEmpleados/Index.vue'),
    meta: {
      acceso: true,
    },
  },
  {
    path: '/log',
    name: 'log',
    component: Log,
    meta: {
      acceso: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.matched.some(record => record.meta.libre)) {
    next();
  } else if (store.state.usuario) {
    if (to.matched.some(record => record.meta.acceso)) {
      next();
    }
  } else {
    next({
      name: 'Login',
    });
  }
});

export default router;
